import classNames from "classnames";
import { Lottie } from "../..";
import { Typography, Box } from "..";
import loadingAnim from "./assets/loaderAnimation.json";
import { useStyles } from "./styles";

export interface Props {
  message: string;
  fullScreen?: boolean;
  "data-testid"?: string;
  className?: string;
}

const PageLoading = ({
  message,
  fullScreen = false,
  className,
  ...rest
}: Props): JSX.Element => {
  const styles = useStyles({ fullScreen });

  return (
    <div className={classNames(styles.root, className)} {...rest}>
      <Box width="100px" mb={2}>
        <Lottie animationData={loadingAnim} />
      </Box>
      <Typography aria-live="assertive" aria-label={message}>
        {message}
      </Typography>
    </div>
  );
};

export default PageLoading;
